import {
  SelectionList,
  SelectionListItemProps,
  Text,
  TextWithHighlight,
} from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';
import { ComponentProps, memo } from 'react';

import styles from './analyticsFilterItem.module.scss';

type AnalyticsFilterItemProps<TValue> = {
  value: TValue;
  label: string;
  highlight?: string;
  color?: string;
  isDisabled?: boolean;
  textProps?: Partial<ComponentProps<typeof Text.Paragraph>>;
} & SelectionListItemProps<TValue> &
  PropsWithClassName &
  PropsWithChildren;

const AnalyticsFilterItem = <TValue,>({
  className,
  contentClassName,
  children,
  value,
  label,
  highlight,
  color,
  isDisabled = false,
  textProps,
  ...selectionListItemProps
}: AnalyticsFilterItemProps<TValue>): JSX.Element => {
  return (
    <SelectionList.Item<TValue>
      className={classNames(styles.root, className)}
      contentClassName={classNames(styles.content, contentClassName)}
      value={value}
      isDisabled={isDisabled}
      {...selectionListItemProps}
    >
      {color && (
        <div
          className={styles.colorIndicator}
          style={{
            backgroundColor: color,
          }}
        />
      )}

      <Text.Paragraph {...textProps}>
        <TextWithHighlight text={label} highlight={highlight} />
      </Text.Paragraph>

      {children}
    </SelectionList.Item>
  );
};

const _AnalyticsFilterItem = memo(
  AnalyticsFilterItem,
) as typeof AnalyticsFilterItem;

export { _AnalyticsFilterItem as AnalyticsFilterItem };
